import { Directive, ElementRef } from '@angular/core';
import { ConfigProvider } from '../../providers/config/config';
import { AdsProvider } from '../../providers/ads/ads';

/**
 * Generated class for the GoogleAdsDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[google-ads]' // Attribute selector
})
export class GoogleAdsDirective {

  constructor(el: ElementRef, config: ConfigProvider, ads: AdsProvider) {
    console.log('in GOOGLE ADS')
    config.config.then((conf) => {
      let adsConfig = conf.ads;

      (el.nativeElement as HTMLElement).setAttribute("data-ad-slot", adsConfig.adSlotId);
      (el.nativeElement as HTMLElement).setAttribute("data-ad-client", adsConfig.adClientId);
      (el.nativeElement as HTMLElement).setAttribute("class", "adsbygoogle");
      (el.nativeElement as HTMLElement).setAttribute("style", "display:inline-block;width:100%;height:50px");

      ads.initAds();
    })
  }

}



// WEBPACK FOOTER //
// /src/directives/google-ads/google-ads.ts